<template>
  <div class="subtable">
    <Table :columns="columnsSub" :data="data"   :loading="loading"></Table>
  </div>
</template>
<script>
  import {checkinRateListForHouse} from "../../../../api/reporter";
  import {deepClone} from "../../../../utils/format";

  export default {
    // name: "subtable",
    props:{
      columns:{
        type:Array,
        default:function(){return []}
      },
      params:{
        type:Object,
        default:null
      },
      currentData:{
        type:String,
        default:''
      }
    },
    computed:{
      columnsSub(){
        if(this.columns.length===0){
          return []
        }

        const ret=deepClone(this.columns)
        ret[0].type=''
        ret[0].render=null
        ret[1].key='houseTypeName'
        return ret
      }


    },
    data(){
      return {
        data:[],
        loading:true
      }
    },
    methods:{
      setData(data) {

        if (data.length === 0) {
          this.data = []
          return
        }
        const ret = []
        if (['days7','days30','byself'].indexOf(this.currentData) !== -1) {


          data.forEach((ele)=>{
            const d={}
            d['projectFid']=ele.projectFid
            d['houseTypeName']=ele.houseTypeName
            ele.info.forEach((ele1,index1)=>{
              d['checkinRate' + index1]=ele1.checkinRate.value
              d['rented' + index1]=ele1.rented.quantity
              d['stock' + index1]=ele1.stock.quantity
            })
            ret.push(d)
          })
          this.data=ret
          // console.log(this.data)
        }
        if(['byweek','bymonth'].indexOf(this.currentData) !== -1){

          data.forEach((ele)=>{
            const d={}
            d['houseTypeName']=ele.houseTypeName
            ele.info.forEach((ele1,index1)=>{
              d['checkinRate' + index1]=ele1.checkinRate.value
            })
            ret.push(d)
          })

          this.data=ret
        }
      },

    },
    created(){
      checkinRateListForHouse(this.params).then(res=>{
        if(!res.data){
          return
        }
        this.setData(res.data.rows)
      }).catch(error=>[

      ]).finally(()=>{
        this.loading=false

      })

    }
  }
</script>

<style scoped>

</style>
